import type { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface InfoNoticeProps {
  title: string;
  children: ReactNode;
  icon?: string;
  delay?: number;
}

export default function InfoNotice({
  title,
  children,
  icon = 'ri-information-line',
  delay = 0,
}: InfoNoticeProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.35 }}
      className="rounded-2xl bg-navy/5 border border-navy/10 p-5"
    >
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-lg bg-navy/10 flex items-center justify-center text-navy shrink-0 mt-0.5">
          <i className={`${icon} text-sm`} />
        </div>
        <div>
          <p className="text-xs font-semibold text-navy mb-1.5">{title}</p>
          <div className="text-[11px] text-navy-light leading-relaxed">{children}</div>
        </div>
      </div>
    </motion.div>
  );
}
